import { render, staticRenderFns } from "./SelectLocal.vue?vue&type=template&id=2718aa6e"
import script from "./SelectLocal.vue?vue&type=script&lang=js"
export * from "./SelectLocal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports